import service from "./service.json";
import privacy from "./privacy.json";
import collection from "./collection.json";
import outsourcing from "./outsourcing.json";

export type LegalBlock =
  | { type: "title" | "heading" | "paragraph"; text: string }
  | { type: "list"; ordered: boolean; items: { text: string; children?: string[] }[] }
  | { type: "table"; rows: string[][] };

export interface LegalPolicy { title: string; version: string; blocks: LegalBlock[]; }

const servicePolicy = service as LegalPolicy;
const privacyPolicy = privacy as LegalPolicy;
export const legalPolicies: Record<string, LegalPolicy> = {
  service: servicePolicy,
  privacy: collection as LegalPolicy,
  privacyPolicy,
  consignment: outsourcing as LegalPolicy,
};
